/* Ruckstuhl V8 – scoped locale bridge for legacy configurator UI
   2026-10-07 performance fix:
   - no full-document translation walk on non-DE locales
   - no full-document character/attribute observer
   - runtime translation is limited to configurator roots and their triggers
   - observers are disconnected while translations are written, preventing feedback loops
*/
(function(){
  'use strict';

  function data(){
    var el=document.getElementById('rk-v8-i18n-data');
    if(!el)return {strings:{},exact:{}};
    try{return JSON.parse(el.textContent||'{}')}catch(e){return {strings:{},exact:{}}}
  }

  var dict=data();

  function format(value,vars){
    var out=String(value==null?'':value);
    Object.keys(vars||{}).forEach(function(k){
      out=out.replace(new RegExp('\\{'+k+'\\}','g'),String(vars[k]));
    });
    return out;
  }

  function t(key,fallback,vars){
    return format((dict.strings&&dict.strings[key])||fallback||key,vars||{});
  }
  window.RKV8T=t;

  function translateText(text){
    var trim=String(text||'').trim();
    if(!trim)return null;
    if(dict.exact&&Object.prototype.hasOwnProperty.call(dict.exact,trim))return dict.exact[trim];

    var m=trim.match(/^(\d+) Muster ausgewählt$/);
    if(m)return t('samples_selected_count',trim,{count:m[1]});
    m=trim.match(/^Zusatzteppich\s+(\d+)$/);
    if(m)return t('additional_rug',trim,{count:m[1]});
    m=trim.match(/^Passend zu\s+(.+)$/);
    if(m)return t('matching_to',trim,{value:m[1]});
    m=trim.match(/^(Länge|Breite|Tiefe|Durchmesser)\s+(.+)$/);
    if(m){
      var measureKeys={Länge:'length',Breite:'width',Tiefe:'ui_depth',Durchmesser:'diameter'};
      return t(measureKeys[m[1]],m[1])+' '+m[2];
    }
    m=trim.match(/^Ausgewählt:\s*(.+)$/);
    if(m)return t('ui_selected_prefix','Ausgewählt:')+' '+m[1];
    m=trim.match(/^Rollenbreite:\s*(.+)$/);
    if(m)return t('ui_roll_width','Rollenbreite')+': '+m[1];
    m=trim.match(/^Rollenlänge:\s*(.+)$/);
    if(m)return t('ui_roll_length','Rollenlänge')+': '+m[1];
    m=trim.match(/^(\d+(?:[.,]\d+)?)\s*km entfernt$/);
    if(m)return t('ui_distance_away',trim,{distance:m[1]});
    return null;
  }

  function translatedNodeValue(node){
    var current=String(node&&node.nodeValue||'');
    var repl=translateText(current);
    if(repl===null)return null;
    var lead=(current.match(/^\s*/)||[''])[0];
    var trail=(current.match(/\s*$/)||[''])[0];
    return lead+repl+trail;
  }

  function excluded(el){
    return !!(el&&el.closest&&el.closest('[data-rk-no-runtime-translate]'));
  }

  function translateAttributes(el){
    if(!el||el.nodeType!==1||excluded(el))return;
    ['aria-label','placeholder','title','alt'].forEach(function(attr){
      if(!el.hasAttribute(attr))return;
      var current=el.getAttribute(attr);
      var repl=translateText(current);
      if(repl!==null&&current!==repl)el.setAttribute(attr,repl);
    });
    if(el.matches&&el.matches('input[type=submit][value],input[type=button][value],input[type=reset][value]')){
      var current=el.value;
      var repl=translateText(current);
      if(repl!==null&&current!==repl)el.value=repl;
    }
  }

  function walk(root){
    if(!root)return;
    if(root.nodeType===1&&excluded(root))return;

    if(root.nodeType===1)translateAttributes(root);

    var walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{
      acceptNode:function(n){
        var p=n.parentElement;
        if(!p||/^(SCRIPT|STYLE|TEXTAREA)$/i.test(p.tagName)||excluded(p))return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes=[];
    while(walker.nextNode())nodes.push(walker.currentNode);
    nodes.forEach(function(n){
      var next=translatedNodeValue(n);
      if(next!==null&&n.nodeValue!==next)n.nodeValue=next;
    });

    if(root.querySelectorAll){
      root.querySelectorAll('[aria-label],[placeholder],[title],[alt],input[type=submit][value],input[type=button][value],input[type=reset][value]').forEach(translateAttributes);
    }
  }

  /* Legacy JS dialogs can still be emitted outside an individual configurator root. */
  var nativeAlert=window.alert&&window.alert.bind(window),
      nativeConfirm=window.confirm&&window.confirm.bind(window),
      nativePrompt=window.prompt&&window.prompt.bind(window);
  if(nativeAlert)window.alert=function(message){var translated=translateText(message);return nativeAlert(translated===null?message:translated);};
  if(nativeConfirm)window.confirm=function(message){var translated=translateText(message);return nativeConfirm(translated===null?message:translated);};
  if(nativePrompt)window.prompt=function(message,defaultValue){var translated=translateText(message);return nativePrompt(translated===null?message:translated,defaultValue);};

  /* Only these legacy configurator surfaces need the runtime bridge.
     Normal page content is handled by Shopify locale files / T Lab. */
  var CONFIG_ROOT_SELECTOR=[
    '[data-tk]',
    '[data-rk-at-modal]',
    '[data-rk-at-trigger]',
    '[data-rk-rb-modal]',
    '[data-rk-rb-trigger]',
    '.rk-tile-modal',
    '[data-rk-tile-trigger]',
    '[data-rk-maglia-modal]',
    '[data-rk-maglia-open]',
    '[data-rk-configurator-collection-entry]',
    '[data-rk-project-configurator]',
    '[data-rk-config-stage]',
    '[data-configurator-area]',
    '[data-configurator-mount]',
    '[data-rk-configs]'
  ].join(',');

  var observed=new WeakMap();

  function observeOptions(){
    return {
      subtree:true,
      childList:true,
      characterData:true,
      attributes:true,
      attributeFilter:['aria-label','placeholder','title','alt','value']
    };
  }

  function isCoveredByObservedAncestor(root){
    var p=root&&root.parentElement;
    while(p){
      if(observed.has(p))return true;
      p=p.parentElement;
    }
    return false;
  }

  function collapseTargets(root,targets){
    if(!targets.length)return [];
    if(targets.length>40)return [root];

    var unique=[];
    targets.forEach(function(el){
      if(!el||el.nodeType!==1||!root.contains(el))return;
      if(unique.indexOf(el)===-1)unique.push(el);
    });

    return unique.filter(function(el){
      return !unique.some(function(other){return other!==el&&other.contains(el);});
    });
  }

  function installRoot(root){
    if(!root||root.nodeType!==1||observed.has(root)||isCoveredByObservedAncestor(root))return;

    var state={observer:null,queued:false,pending:[]};
    var observer=new MutationObserver(function(records){
      records.forEach(function(r){
        Array.prototype.forEach.call(r.addedNodes||[],function(n){
          var el=n.nodeType===1?n:(n.parentElement||null);
          if(el&&root.contains(el))state.pending.push(el);
        });
        if(r.type==='characterData'&&r.target&&r.target.parentElement)state.pending.push(r.target.parentElement);
        if(r.type==='attributes'&&r.target&&r.target.nodeType===1)state.pending.push(r.target);
      });

      if(!state.pending.length||state.queued)return;
      state.queued=true;
      requestAnimationFrame(function(){
        state.queued=false;
        if(!document.documentElement.contains(root)){
          observer.disconnect();
          return;
        }
        var targets=collapseTargets(root,state.pending);
        state.pending.length=0;

        /* Prevent our own text/attribute writes from generating another observer cycle. */
        observer.disconnect();
        targets.forEach(walk);
        observer.observe(root,observeOptions());
      });
    });

    state.observer=observer;
    observed.set(root,state);

    /* Translate the legacy markup once, then watch only this configurator surface. */
    walk(root);
    observer.observe(root,observeOptions());
  }

  function discover(scope){
    if(!scope)return;
    if(scope.nodeType===1&&scope.matches&&scope.matches(CONFIG_ROOT_SELECTOR))installRoot(scope);
    if(scope.querySelectorAll){
      scope.querySelectorAll(CONFIG_ROOT_SELECTOR).forEach(installRoot);
    }
  }

  function init(){
    var lang=String(document.documentElement.lang||'de').toLowerCase();

    /* German legacy markup is native; no runtime translation or observers needed. */
    if(lang==='de'||lang.indexOf('de-')===0)return;

    /* Initial pass is limited to configurator roots, never the full document. */
    discover(document);

    /* Cheap discovery observer: only detects newly inserted configurator roots.
       It does NOT watch global text/attributes. Dynamic changes inside a configurator
       are handled by that configurator's own scoped observer. */
    var discoveryObserver=new MutationObserver(function(records){
      records.forEach(function(r){
        Array.prototype.forEach.call(r.addedNodes||[],function(n){
          if(n.nodeType===1)discover(n);
        });
      });
    });
    discoveryObserver.observe(document.documentElement,{subtree:true,childList:true});

    /* Optional hook for configurator code that injects a known fragment and wants
       an immediate translation without waiting for a mutation frame. */
    window.RKV8TranslateRoot=function(root){
      if(!root)return;
      var el=root.nodeType===1?root:(root.parentElement||null);
      if(!el)return;
      var configRoot=el.matches&&el.matches(CONFIG_ROOT_SELECTOR)?el:(el.closest?el.closest(CONFIG_ROOT_SELECTOR):null);
      if(configRoot){installRoot(configRoot);walk(el);}
    };
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
